import api from "../services/api";
import { clearNonNumericCharacters } from "../utils/functions";

const baseURL = 'https://servicodados.ibge.gov.br/api/v1/localidades/';

export function getVIACEPAddressByCEP(cep) {

    const clean_cep = clearNonNumericCharacters(cep);

    const response = api.get(`https://viacep.com.br/ws/${clean_cep}/json/`)

    return response;
};

export function getIBGEUFs() {

    const response = api.get(baseURL + "estados")

    return response;
};

export function getIBGECitiesByUF(uf) {

    api.get(baseURL + `estados/${uf}/municipios`)
        .then(response => {

        })
        .catch(e => {
        });
};

export function getCNPJData(cnpj) {
    const response = api.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`)
    return response;
};


